module.exports = __webpack_public_path__ + "static/media/badge-spanish-provisional.3ad33bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/badges/badge-spanish-provisional.png
// module id = 604
// module chunks = 0